<template>
  <div id="auth_page" class="row white w-100 h-100 align-items-center">
    <div class="col-12 auth">
      <div class="content">
        <img src="@/assets/images/logo.png" id="logo" />

        <form @submit.prevent="submit">

          <h6 class="text-center mb-4">Alterar senha</h6>
          
          <InputText
            type="tel"
            v-model="loginForm.code"
            :error="formErrors.code"
            class="mb-3"
            maxlength="8"
            placeholder="Digite o código enviado no e-mail"
          />

          <InputText
            type="password"
            v-model="loginForm.password"
            :error="formErrors.password"
            class="mb-3"
            placeholder="Digite sua nova senha"
          />

          <InputText
            type="password"
            v-model="loginForm.password_confirmation"
            :error="formErrors.password_confirmation"
            class="mb-3"
            placeholder="Repita sua nova senha"
          />

          <PrimaryButtonLoader v-if="loading" class="w-100 d-block mt-4"></PrimaryButtonLoader>
          <PrimaryButton v-else type="submit" class="w-100 d-block mt-4">Alterar</PrimaryButton>
          <p v-if="error">{{ errorMessage }}</p>
        </form>
      </div>
    </div>
  </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { useAuthStore } from '@/stores/AuthStore'
  import { useRouter } from 'vue-router'
  import InputText from '@/components/InputText.vue'
  import PrimaryButton from '@/components/PrimaryButton.vue'
  import PrimaryButtonLoader from '@/components/PrimaryButtonLoader.vue'
  import { useToast, TYPE } from "vue-toastification"
  import {errorFormat} from "@/utils/errorFormat";
  
  const loading = ref(false);

  const loginForm = ref({ password: '', password_confirmation: '', code: '' })
  const authStore = useAuthStore()
  const router = useRouter()

  const formErrors = ref({});
  const toast = useToast();
  
  const submit = async () => {
    formErrors.value = {};
    loading.value = true;

    const formResult = await authStore.changePassword(loginForm.value);
    if(formResult.success){
      toast('Senha alterada com sucesso', { type: TYPE.SUCCESS, timeout: 6000 });
      router.push({ name: 'login' })
    }
    else {
      formErrors.value = errorFormat(formResult.errors);
    }
    loading.value = false;
  }
  </script>
  
  <style scoped>
  body {
    background-color: #fff;
  }

  .auth {
    max-width: 800px;
    margin: auto;
  }
  </style>